import { angularJsApp } from "../app";
import { AppComponentsEnum } from "../app.model";
import { IApiCentre } from "../services/api.model";
import { ConfiguracioService } from "../services/configuracio.service";

class Component {
  centre: IApiCentre;
  url: string;
  isLoading = true;
  resolve: { centre: IApiCentre; };
  modalInstance: ng.ui.bootstrap.IModalInstanceService;

  constructor(
    private Configuracio: ConfiguracioService,
    private $scope: ng.IScope,
    private $sce: ng.ISCEService,
  ) { }

  $onInit() {
    this.centre = this.resolve.centre;
    this.url = this.$sce.trustAsResourceUrl(this.Configuracio.getConfiguracio().adrecaFDC + this.centre.codiCentre);
  }

  ok(): void {
    this.modalInstance.close();
  }

  public iframeLoaded(): void {
    this.$scope.$apply(() => {
      this.isLoading = false;
    });
  }
}

const component: ng.IComponentOptions = {
  bindings: {
    modalInstance: "<",
    resolve: "<",
  },
  templateUrl: './components/modal-fitxa-centre.component.html',
  controller: Component,
};

angularJsApp.component(AppComponentsEnum.FITXA_CENTRE, component);